import { Stack } from '@mui/material';
import { twMerge } from 'tailwind-merge';

export type BadgeTabProps = {
  label: string;
  status: number;
};

export function BadgeTab({ label, status }: BadgeTabProps) {
  return (
    <Stack direction="row" alignItems="center" gap="8px">
      {label}
      <div
        className={twMerge(
          'tab-label-badge',
          'mt-[-3px] h-16 w-16 rounded-sm bg-stone-200 bg-opacity-50',
          'text-center text-[10px] font-semibold leading-[18px] tracking-tight text-white'
        )}
      >
        {status}
      </div>
    </Stack>
  );
}
